import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

import {
  shiftBlockIncludedMetaDataSchema,
  shiftBlockSchema,
} from "../../ShiftBlocks/api/useFetchPaginatedShiftBlocks";

const nonPaginatedTravelBlocksRequestSchema = z.object({
  page: z.object({
    size: z.number(),
  }),
});

const nonPaginatedTravelBlocksResponseSchema = z.object({
  data: z.array(shiftBlockSchema),
  included: z.array(shiftBlockIncludedMetaDataSchema),
});

export type NonPaginatedTravelBlocksRequest = z.infer<typeof nonPaginatedTravelBlocksRequestSchema>;
export type NonPaginatedTravelBlocksResponse = z.infer<
  typeof nonPaginatedTravelBlocksResponseSchema
>;

export const travelBlocksApiUrl = `${environmentConfig.REACT_APP_BASE_API_URL}/travel-blocks`;

export function useFetchTravelBlocks(
  params: NonPaginatedTravelBlocksRequest,
  options: UseQueryOptions<NonPaginatedTravelBlocksResponse, AxiosError> = {}
): UseQueryResult<NonPaginatedTravelBlocksResponse> {
  return useQuery({
    queryKey: [travelBlocksApiUrl, params],
    queryFn: async () => {
      const response = await get({
        url: travelBlocksApiUrl,
        queryParams: {
          page: params.page,
          sort: "distance,startTime",
        },
        responseSchema: nonPaginatedTravelBlocksResponseSchema,
        requestSchema: nonPaginatedTravelBlocksRequestSchema,
      });
      return response.data;
    },
    ...options,
  });
}
